import { useIntl } from 'react-intl'

import type { TagEditorProps } from './TagEditor.types'
import { DEFAULT_TAG_COLOR } from './tagging.constants'
import { tagColorBorder, tagColorToHex } from './tagging.utils'
import { useTagging } from './useTagging'

export const TagEditor = (props: TagEditorProps) => {
  const { disabled, onExit } = props
  const intl = useIntl()
  const tagging = useTagging()

  const isDefaultColor = tagging.selectedColor === DEFAULT_TAG_COLOR
  const bgColor = isDefaultColor ? '#ffffff' : tagColorToHex(tagging.selectedColor)
  const borderColor = isDefaultColor ? '#ced4da' : tagColorBorder(tagging.selectedColor)

  return (
    <span
      className="TagPill TagEditor"
      style={{
        backgroundColor: bgColor,
        borderColor,
      }}
    >
      {/* eslint-disable jsx-a11y/no-autofocus -- editor must focus on open */}
      <input
        ref={tagging.inputRef}
        autoFocus
        className="TagEditor-input"
        disabled={disabled}
        onChange={e => tagging.setInputText(e.target.value)}
        placeholder=""
        type="text"
        value={tagging.inputText}
      />
      {/* eslint-enable jsx-a11y/no-autofocus */}
      <button
        aria-label={intl.formatMessage({ id: 'Tags_close_editor' })}
        className="TagEditor-close"
        disabled={disabled}
        onClick={onExit}
        type="button"
      >
        &#x2715;
      </button>
    </span>
  )
}
